import _sfc_main from "./component-library113.mjs";
import "./component-library114.mjs";
import normalizeComponent from "./component-library81.mjs";
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
  return _c(_setup.InputWrapper, { staticClass: "radio-group", attrs: { "error-message": _vm.errorMessage, "required": _vm.required, "disabled": _vm.disabled } }, [_c("div", { staticClass: "radio-group__container", class: {
    "radio-group__container--vertical-xs": _vm.verticalXs,
    "radio-group__container--vertical-sm": _vm.verticalSm,
    "radio-group__container--vertical-md": _vm.verticalMd,
    "radio-group__container--vertical-lg": _vm.verticalLg
  } }, _vm._l(_vm.options, function(item, key) {
    return _c(_setup.RadioInput, { key, attrs: { "value": _setup.inputValue, "name": _vm.name, "label": `${_vm.name}-${item.value}`, "val": item.value }, on: { "input": function($event) {
      return _vm.$emit("input", $event);
    } } }, [_vm._t("default", function() {
      return [_c("span", { domProps: { "innerHTML": _vm._s(item.label) } })];
    }, { "selected": item.value === _setup.inputValue, "item": item })], 2);
  }), 1)]);
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  "930ffadb",
  null,
  null
);
const radioGroup = __component__.exports;
export {
  radioGroup as default
};
